export enum Experiment {
  enableNavigationInFollowingFollowersModal = 'specs.profilePage.EnableNavigationInFollowingFollowersModal',
}
